import { render } from "./GoogleLogin.vue?vue&type=template&id=57b536ae&scoped=true"
import script from "./GoogleLogin.vue?vue&type=script&lang=js"
export * from "./GoogleLogin.vue?vue&type=script&lang=js"

import "./GoogleLogin.vue?vue&type=style&index=0&id=57b536ae&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b536ae"]])

export default __exports__